import { render, staticRenderFns } from "./Retreats.vue?vue&type=template&id=0ab852b5"
import script from "./Retreats.vue?vue&type=script&lang=js"
export * from "./Retreats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports